import { Box } from '@mui/system';
import React, { useContext, useRef, useState } from 'react';
import CheckBoxComponent from '../../../components/formlib/CheckBoxComponent';
import MediumTypography from '../../../components/formlib/MediumTypography';
import CommentTextbox from '../../../components/formlib/CommentTextbox';
import CustomRadioButton from '../../../components/formlib/CustomRadioButton';
import AutocompleteSearch from '../../../components/formlib/AutocompleteSearch';
import { AlertColor, autocompleteClasses, Grid } from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';
import DatePickerComponent from '../../../components/formlib/DatePickerComponent';
import { OptionType } from '../../../utils/type';
import SignatureComponent from '../../../components/formlib/modal/SignatureComponent';
import ButtonComponent from '../../../components/formlib/ButtonComponent';
import InformationModal from '../../ifsp/InformationModal';
import SnackBarComponent from '../../../components/formlib/SnackBarComponent';

import { ReactComponent as Delete } from '../../../assets/images/deleteAlertIcon.svg';
import { ReactComponent as DownArrow } from '../../../assets/images/downarrowcolored.svg';
import { ReactComponent as UpArrow } from '../../../assets/images/uparrowcolored.svg';
import { ReactComponent as InfoIcon } from '../../../assets/images/infoIcon.svg';
import { ReactComponent as UnDo } from '../../../assets/images/undoIcon1.svg';
import { ReactComponent as Editsignature } from '../../../assets/images/editsignature.svg';
import { useIntl } from 'react-intl';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import {
  createConsent,
  IfspConsentSignatureType,
  updateIfspSDPAndConsent,
} from '../../../redux/features/ifsp/ifspSDPAndConsentSlice';
import IfspConsentSignture from './sDPAndConsentsComponents/IfspConsentSignture';
import { useSDPAndConsentValidationCheck } from './sDPAndConsentsComponents/ifspSDPAndConsentValidationCheck';
import ModalPopup from '../../../components/formlib/ModalPopup';
import { LoaderContext, LoaderContextType } from '../../../layouts/AppSidebar';
import {
  deleteIfspConsent,
  getIfsp,
} from '../../../services/ifspClient/IfspApi';
import {
  setIfspClientDetails,
  updateIfspClientDetails,
} from '../../../redux/features/ifsp/ifspClientDetailsSlice';

const tools = [{ id: 'bdi2', label: 'BDI 3' }];
const clientId = localStorage.getItem('ClientId');

type IfspConsentType = {
  isSaveClicked: boolean;
};

const IfspConsent = ({ isSaveClicked }: IfspConsentType) => {
  const ifspSDPAndConsent = useAppSelector(
    (state) => state.ifspSDPAndConsent.sdpAndConsent,
  );
  const ifspClientDetails = useAppSelector(
    (state) => state.ifspClientDetails.ifspClientDetails,
  );

  const ifspPermission = useAppSelector((state) => state.ifspPermissionDetails);

  const ifspSDPAndConsentFormValidations =
    useSDPAndConsentValidationCheck(ifspSDPAndConsent);

  const dispatch = useAppDispatch();
  const [openAccordianIndex, setOpenAccordianIndex] = useState<number>(0);
  const [openAccordian, setOpenAccordian] = useState<boolean>(false);
  const [openConsentInfoModal, setOpenConsentInfoModal] =
    useState<boolean>(false);
  const [signClicked, setSignClicked] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [toastrVariable, setToastrVariable] = useState<AlertColor>('info');
  const [toastrDefaultMessage, setToastrDefaultMessage] = useState<string>('');
  const [consentDeleteDetails, setConsentDeleteDetails] = useState<{
    consentId: string | null;
    consentIndex: number | null;
  }>({
    consentId: null,
    consentIndex: null,
  });
  const [openConsentDeleteWarning, setOpenConsentDeleteWarning] =
    useState<boolean>(false);
  const [toastrId, setToastrId] = useState<string>('');

  const rctl = useIntl();
  const parentRef = useRef<HTMLDivElement>(null);

  const { toggleLoader } = useContext(LoaderContext) as LoaderContextType;

  const showAddSectionCreationUi = (mainIndex: number) => {
    return mainIndex === ifspSDPAndConsent.consent.length - 1 &&
      !ifspSDPAndConsent.isLocked &&
      ifspSDPAndConsent.consent[mainIndex]?.consentType === 'consent' ? (
      <Box
        component={'div'}
        className="cursorPointer flex__ align__items__center pr-md"
        onClick={() => {
          dispatch(
            updateIfspSDPAndConsent({
              ...ifspSDPAndConsent,
              consent: ifspSDPAndConsent.consent.map((item, index) => {
                if (index === mainIndex) {
                  return {
                    ...item,
                    consentType: 'consentForChange',
                  };
                }
                return item;
              }),
            }),
          );
        }}
        sx={{
          padding: '4px 8px 4px 8px',
          borderRadius: '4px',
          marginRight: '24px',
          border: '1px solid #008C82',
          backgroundColor: '#fff',
        }}
      >
        <Box sx={{ display: 'flex' }} className="pr-xs">
          {mainIndex > 0 && <UnDo style={{ width: '14px', height: '14px' }} />}
        </Box>
        <MediumTypography
          labelid={
            mainIndex === 0 ? 'IFSP.ConvertToConsentForChange' : 'IFSP.UnDo'
          }
          defaultlabel={
            mainIndex === 0 ? 'Convert To Consent For Change' : 'Undo'
          }
          fontSize="12px"
          fontweight={600}
        />
      </Box>
    ) : (
      mainIndex === ifspSDPAndConsent.consent.length - 1 &&
        !ifspSDPAndConsent.isLocked &&
        ifspSDPAndConsent.consent[mainIndex]?.consentType ===
          'consentForChange' && (
          <Box
            className="cursorPointer flex__ align__items__center pr-md"
            sx={{
              padding: '4px 8px 4px 8px',
              borderRadius: '4px',
              marginRight: '24px',
              border: '1px solid #008C82',
              backgroundColor: '#fff',
            }}
            onClick={() => {
              dispatch(
                updateIfspSDPAndConsent({
                  ...ifspSDPAndConsent,
                  consent: ifspSDPAndConsent.consent.map((item, index) => {
                    if (index === mainIndex) {
                      return {
                        ...item,
                        consentType: 'consent',
                      };
                    }
                    return item;
                  }),
                }),
              );
            }}
          >
            <Box sx={{ display: 'flex' }} className="pr-xs">
              {mainIndex === 0 && (
                <UnDo style={{ width: '14px', height: '14px' }} />
              )}
            </Box>
            <MediumTypography
              labelid={mainIndex === 0 ? 'IFSP.UnDo' : 'IFSP.ConvertToConsent'}
              defaultlabel={mainIndex === 0 ? 'Undo' : 'Convert To Consent'}
              fontSize="12px"
              fontweight={600}
            />
          </Box>
        )
    );
  };

  const labelValue = (
    mainIndex: number,
    consentTypeValue: string,
    consentForChnageTypeValye: string,
  ) => {
    if (ifspSDPAndConsent.consent[mainIndex]?.isAdminAmendment) {
      return 'Admin Amendment';
    } else if (
      ifspSDPAndConsent.consent[mainIndex]?.consentType === 'consentForChange'
    ) {
      return consentForChnageTypeValye;
    } else {
      return consentTypeValue;
    }
  };

  const showSessionReviewedDate = (date: string | Dayjs | null) => {
    return (
      <Box
        sx={{
          display: 'flex',
          padding: '4px 8px 4px 8px',
          borderRadius: '4px',
          marginLeft: '24px',
          backgroundColor: '#97A6A5',
          alignItems: 'center',
        }}
      >
        <MediumTypography
          labelid="IFSP.CompletedOn"
          defaultlabel="Completed On: "
          fontSize="14px"
          fontweight={400}
          textColor="#fff"
        />
        <MediumTypography
          fontSize="14px"
          fontweight={400}
          textColor="#fff"
          className="pl-xs"
          label={date as string}
        />
      </Box>
    );
  };

  const onCancelClick = () => {
    setSignClicked(!signClicked);
  };

  const onSignatureSave = async (sign: string) => {
    setSignClicked(!signClicked);
    dispatch(
      updateIfspSDPAndConsent({
        ...ifspSDPAndConsent,
        consent: ifspSDPAndConsent.consent.map((item, index) => {
          if (index === openAccordianIndex) {
            return {
              ...item,
              adminAmendmentSignature: {
                ...item.adminAmendmentSignature,
                partitionKey: '',
                rowKey: '',
                signature: sign,
              },
            };
          }
          return item;
        }),
      }),
    );
  };

  const clearSignature = () => {
    dispatch(
      updateIfspSDPAndConsent({
        ...ifspSDPAndConsent,
        consent: ifspSDPAndConsent.consent.map((item, index) => {
          if (index === openAccordianIndex) {
            return {
              ...item,
              adminAmendmentSignature: {
                ...item.adminAmendmentSignature,
                partitionKey: '',
                rowKey: '',
                signature: '',
              },
            };
          }
          return item;
        }),
      }),
    );
    setOpen(true);
    setToastrVariable('success');
    setToastrId('ProgressNote.signatureResetedsuccess');
    setToastrDefaultMessage('Signature Reset Successfully');
    setSignClicked(!signClicked);
  };
  const handleSuccess = (successError: AlertColor, id: string, mes: string) => {
    setOpen(true);
    setToastrVariable(successError);
    setToastrId(id);
    setToastrDefaultMessage(mes);
  };

  const handleDeleteConsent = () => {
    toggleLoader(true);
    if (consentDeleteDetails.consentId) {
      deleteIfspConsent(consentDeleteDetails.consentId)
        .then(() => {
          dispatch(
            updateIfspSDPAndConsent({
              ...ifspSDPAndConsent,
              consent: ifspSDPAndConsent.consent.filter(
                (item) => item.id !== consentDeleteDetails.consentId,
              ),
            }),
          );
          getIfsp(clientId ?? '')
            .then((res) => {
              dispatch(setIfspClientDetails(res));
              dispatch(
                updateIfspClientDetails({
                  reviewHistory: res.reviewHistory,
                }),
              );
            })
            .catch(() => {
              setOpen(true);
              setToastrVariable('error');
              setToastrId('IFSP.Consent.DeleteError');
              setToastrDefaultMessage(
                'Failed to update IFSP details after deletion',
              );
            });
          setOpen(true);
          setToastrId('IFSP.Consent.DeleteSuccess');
          setToastrDefaultMessage('Consent deleted Successfully');
          setToastrVariable('success');
        })
        .catch(() => {
          toggleLoader(false);
          setOpen(true);
          setToastrVariable('error');
          setToastrId('IFSP.Consent.DeleteError');
          setToastrDefaultMessage('Failed to delete consent');
        })
        .finally(() => {
          toggleLoader(false);
          setConsentDeleteDetails({ consentId: '', consentIndex: null });
          setOpenConsentDeleteWarning(false);
        });
    } else {
      dispatch(
        updateIfspSDPAndConsent({
          ...ifspSDPAndConsent,
          consent: ifspSDPAndConsent.consent.filter(
            (_, index) => index !== consentDeleteDetails.consentIndex,
          ),
        }),
      );
      toggleLoader(false);
      setConsentDeleteDetails({ consentId: '', consentIndex: null });
      setOpenConsentDeleteWarning(false);
    }
  };

  const handleCloseSnakBar = (
    _event?: React.SyntheticEvent | Event,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleConsentToAccessInsuranceSignature = (
    updatedSignature: IfspConsentSignatureType,
    index: number,
  ) => {
    dispatch(
      updateIfspSDPAndConsent({
        ...ifspSDPAndConsent,
        consent: ifspSDPAndConsent.consent.map((consent, consentIndex) => {
          if (consentIndex === openAccordianIndex) {
            return {
              ...consent,
              consentToAccessInsuranceSignature:
                consent.consentToAccessInsuranceSignature.map((item, i) => {
                  if (i === index) {
                    return updatedSignature;
                  }
                  return item;
                }),
            };
          }
          return consent;
        }),
      }),
    );
  };

  const handleConsentForServiceSignature = (
    updatedSignature: IfspConsentSignatureType,
    index: number,
  ) => {
    dispatch(
      updateIfspSDPAndConsent({
        ...ifspSDPAndConsent,
        consent: ifspSDPAndConsent.consent.map((consent, consentIndex) => {
          if (consentIndex === openAccordianIndex) {
            return {
              ...consent,
              consentForServiceSignature:
                consent.consentForServiceSignature.map((item, i) =>
                  i === index ? updatedSignature : item,
                ),
            };
          }
          return consent;
        }),
      }),
    );
  };

  const getConsentBorderColor = (mainIndex: number): string => {
    const isLastConsent =
      !ifspSDPAndConsent.isLocked &&
      ifspSDPAndConsent.consent.length - 1 === mainIndex;

    const hasValidationError =
      ifspSDPAndConsentFormValidations.adminAmendmentSignDate.some(
        (item) => item.errorIndex === mainIndex,
      ) ||
      ifspSDPAndConsentFormValidations.adminAmendmentSignature.some(
        (item) => item.errorIndex === mainIndex,
      ) ||
      ifspSDPAndConsentFormValidations.assessmentCompletedOn.some(
        (item) => item.errorIndex === mainIndex,
      ) ||
      ifspSDPAndConsentFormValidations.consentForServiceSignatureDateOne.some(
        (item) => item.errorIndex === mainIndex,
      ) ||
      ifspSDPAndConsentFormValidations.consentForServiceSignatureDateTwo.some(
        (item) => item.errorIndex === mainIndex,
      ) ||
      ifspSDPAndConsentFormValidations.consentToAccessInsuranceSignatureDateOne.some(
        (item) => item.errorIndex === mainIndex,
      ) ||
      ifspSDPAndConsentFormValidations.consentToAccessInsuranceSignatureDateTwo.some(
        (item) => item.errorIndex === mainIndex,
      ) ||
      ifspSDPAndConsentFormValidations.reestablishedDate.some(
        (item) => item.errorIndex === mainIndex,
      ) ||
      ifspSDPAndConsentFormValidations.consentForServiceagreeDisagreeService.some(
        (item) => item.errorIndex === mainIndex,
      );

    if (isLastConsent) {
      return '1px solid #F96300';
    }

    if (hasValidationError && isSaveClicked) {
      return '1px solid red';
    }

    return '1px solid #00C6B8';
  };

  return (
    <Box component="main">
      <SnackBarComponent
        open={open}
        handleClose={handleCloseSnakBar}
        successOrError={toastrVariable}
        labelId={toastrId}
        defaultMessageId={toastrDefaultMessage}
      />
      <ModalPopup
        open={openConsentDeleteWarning}
        description="permanentDeleteConfirmationMessage"
        onOk={() => {
          handleDeleteConsent();
        }}
        onCancel={() => {
          setOpenConsentDeleteWarning(false);
        }}
        labelId1="Clientpage.cancelbtn"
        negativeActionLabel="cancelText"
        labelId2="Clientpage.Okbtn"
        positiveActionLabel="Ok"
      />
      <InformationModal
        open={openConsentInfoModal}
        titleLabel="IFSP.Information"
        titleDefaultLabel="Information"
        buttonLabel="IFSP.InfoOkButton"
        buttonDefaultLabel="Ok"
        onClose={() => {
          setOpenConsentInfoModal(false);
        }}
        infoLabelId={
          ifspSDPAndConsent.consent[openAccordianIndex]?.consentType ===
          'consentForChange'
            ? 'IFSP.ConsentForChange.Info'
            : 'IFSP.Consent.Info'
        }
        infoDefaultLabel={
          ifspSDPAndConsent.consent[openAccordianIndex]?.consentType ===
          'consentForChange'
            ? "A review of the Individualized Family Service Plan (IFSP) for a child and the child's family must be conducted every six (6) months or more frequently if conditions warrant or if the family requests a meeting to review the IFSP. The purpose of the periodic review is to determine the degree to which progress toward achieving the results or outcomes identified in the IFSP is being made and/or if modifications or revisions of the results, outcomes or Early Intervention services identified in the IFSP are necessary. The review may be carried out by a meeting or by another means that is acceptable to parents and other participants."
            : 'Early Intervention is a voluntary service and parent(s) have the right to provide, withhold or revoke consent for any and all services. Parents must give written consent before services can begin. Parents may choose to give consent for some services and not others. Your consent means that you agree to the services outlined in this IFSP. If the parents do not give consent for an Early Intervention Service or if they withdraw consent after first giving it, that specific service will not be provided. Any service for which a parent provides consent must be provided within 30 days.'
        }
      />
      {ifspSDPAndConsent.consent.map((ifspData, mainIndex) => (
        <Box
          key={ifspData.id}
          component="section"
          className="p-lg mt-lg borderRadius4"
          sx={{
            border: getConsentBorderColor(mainIndex),
            backgroundColor: '#ECF9F8',
          }}
        >
          <Box component="div" className="flex__justify__space-between">
            {openAccordian && mainIndex === openAccordianIndex ? (
              <Box component="div" className="flex__justify__space-between">
                <MediumTypography
                  labelid={labelValue(
                    mainIndex,
                    'IFSP.session9',
                    'IFSP.ConsentForChanges',
                  )}
                  defaultlabel={labelValue(
                    mainIndex,
                    'Cnsent',
                    'Consent For Changes',
                  )}
                  fontSize="16px"
                  fontweight={600}
                  textColor="#2A4241"
                  className="pr-md"
                />
                <InfoIcon
                  className="cursorPointer"
                  onClick={() => {
                    setOpenConsentInfoModal(true);
                  }}
                />
                {ifspSDPAndConsent.consent[mainIndex].completedOn &&
                  showSessionReviewedDate(
                    ifspSDPAndConsent.consent[mainIndex].completedOn,
                  )}
              </Box>
            ) : (
              <Box className="flex__justify__space-between">
                <MediumTypography
                  labelid={labelValue(
                    mainIndex,
                    'IFSP.session9',
                    'IFSP.ConsentForChanges',
                  )}
                  defaultlabel={labelValue(
                    mainIndex,
                    'Cnsent',
                    'Consent For Changes',
                  )}
                  fontSize="18px"
                  fontweight={600}
                  textColor="#2A4241"
                />
                {ifspSDPAndConsent.consent[mainIndex].completedOn &&
                  showSessionReviewedDate(
                    ifspSDPAndConsent.consent[mainIndex].completedOn,
                  )}
              </Box>
            )}
            {openAccordian && mainIndex === openAccordianIndex ? (
              <Box className="flex__ align__items__center">
                {(ifspSDPAndConsent.consent[mainIndex]?.id
                  ? ifspPermission.hasAdminAmendmentEditPermission
                  : ifspPermission.hasAdminAmendmentAddPermission) &&
                  ((ifspSDPAndConsent.consent.length >= 1 &&
                    ifspSDPAndConsent.consent.length - 1 &&
                    ifspSDPAndConsent.consent[mainIndex].consentType ===
                      'consentForChange' &&
                    !ifspSDPAndConsent.consent[mainIndex].completedOn) ||
                    (ifspSDPAndConsent.consent[mainIndex].completedOn &&
                      !ifspSDPAndConsent.consent[mainIndex].isAdminAmendment &&
                      ifspSDPAndConsent.consent[mainIndex].isConsentSkipped &&
                      ifspSDPAndConsent.consent[mainIndex].consentType ===
                        'consentForChange' &&
                      ifspPermission.hasIfspEditPermissionAfterLock &&
                      ifspPermission.hasClientEditPermission)) && (
                    <Box
                      component={'div'}
                      className="cursorPointer flex__ align__items__center pr-md"
                      onClick={() => {
                        dispatch(
                          updateIfspSDPAndConsent({
                            ...ifspSDPAndConsent,
                            consent: ifspSDPAndConsent.consent.map(
                              (item, index) => {
                                if (index === mainIndex) {
                                  return {
                                    ...createConsent(),
                                    id: item.id,
                                    ifspId: ifspSDPAndConsent.ifspId || '',
                                    adminAmendmentSignature: {
                                      ...item.adminAmendmentSignature,
                                      partitionKey: '',
                                      rowKey: '',
                                      signature: '',
                                      date: null,
                                      verbalConsent: false,
                                    },
                                    consentForServiceSignature:
                                      item.consentForServiceSignature.map(
                                        (servSign) => ({
                                          ...servSign,
                                          signature: '',
                                          date: null,
                                          verbalConsent: false,
                                          partitionKey: '',
                                          rowKey: '',
                                        }),
                                      ),
                                    consentToAccessInsuranceSignature:
                                      item.consentToAccessInsuranceSignature.map(
                                        (insSign) => ({
                                          ...insSign,
                                          signature: '',
                                          date: null,
                                          verbalConsent: false,
                                          partitionKey: '',
                                          rowKey: '',
                                        }),
                                      ),
                                    isAdminAmendment: !item.isAdminAmendment,
                                    consentType: 'consentForChange',
                                    latestConsent: false,
                                  };
                                }
                                return item;
                              },
                            ),
                          }),
                        );
                      }}
                      sx={{
                        padding: '4px 8px 4px 8px',
                        borderRadius: '4px',
                        marginRight: '24px',
                        border: '1px solid #008C82',
                        backgroundColor: '#fff',
                      }}
                    >
                      <Box sx={{ display: 'flex' }} className="pr-xs">
                        {ifspSDPAndConsent.consent[mainIndex]
                          ?.isAdminAmendment && (
                          <UnDo style={{ width: '14px', height: '14px' }} />
                        )}
                      </Box>
                      <MediumTypography
                        labelid={'IFSP.ConvertToAdminAmendment'}
                        defaultlabel={
                          !ifspSDPAndConsent.consent[mainIndex]
                            ?.isAdminAmendment
                            ? 'Convert to Admin Amendment'
                            : 'Undo'
                        }
                        fontSize="12px"
                        fontweight={600}
                      />
                    </Box>
                  )}
                {!ifspSDPAndConsent.consent[mainIndex]?.isAdminAmendment &&
                  ifspPermission.hasClientEditPermission &&
                  showAddSectionCreationUi(mainIndex)}
                {mainIndex !== 0 &&
                  ifspSDPAndConsent.consent[mainIndex]?.completedOn &&
                  (ifspSDPAndConsent.consent[mainIndex]?.isAdminAmendment
                    ? ifspPermission.hasAdminAmendmentDeletePermission
                    : ifspPermission.hasIfspDeletePermissionAfterLock) &&
                  ifspPermission.hasClientEditPermission &&
                  ifspSDPAndConsent.isLocked && (
                    <Delete
                      className="cursorPointer mr-lg"
                      onClick={() => {
                        setOpenConsentDeleteWarning(true);
                        setConsentDeleteDetails({
                          consentId: ifspSDPAndConsent.consent[mainIndex].id,
                          consentIndex: mainIndex,
                        });
                      }}
                    />
                  )}
                <UpArrow
                  className="cursorPointer"
                  onClick={() => {
                    setOpenAccordianIndex((prev) => prev);
                    setOpenAccordian(false);
                  }}
                />
              </Box>
            ) : (
              <Box className="flex__ align__items__center">
                {(ifspSDPAndConsent.consent[mainIndex]?.id
                  ? ifspPermission.hasAdminAmendmentEditPermission
                  : ifspPermission.hasAdminAmendmentAddPermission) &&
                  ((ifspSDPAndConsent.consent.length >= 1 &&
                    ifspSDPAndConsent.consent.length - 1 &&
                    ifspSDPAndConsent.consent[mainIndex].consentType ===
                      'consentForChange' &&
                    !ifspSDPAndConsent.consent[mainIndex].completedOn) ||
                    (ifspSDPAndConsent.consent[mainIndex].completedOn &&
                      !ifspSDPAndConsent.consent[mainIndex].isAdminAmendment &&
                      ifspSDPAndConsent.consent[mainIndex].isConsentSkipped &&
                      ifspSDPAndConsent.consent[mainIndex].consentType ===
                        'consentForChange' &&
                      ifspPermission.hasIfspEditPermissionAfterLock &&
                      ifspPermission.hasClientEditPermission)) && (
                    <Box
                      component={'div'}
                      className="cursorPointer flex__ align__items__center pr-md"
                      onClick={() => {
                        dispatch(
                          updateIfspSDPAndConsent({
                            consent: ifspSDPAndConsent.consent.map(
                              (item, index) => {
                                if (index === mainIndex) {
                                  return {
                                    ...createConsent(),
                                    id: item.id,
                                    ifspId: ifspSDPAndConsent.ifspId || '',
                                    isAdminAmendment: !item.isAdminAmendment,
                                    adminAmendmentSignature: {
                                      ...item.adminAmendmentSignature,
                                      partitionKey: '',
                                      rowKey: '',
                                      signature: '',
                                      date: null,
                                      verbalConsent: false,
                                    },
                                    consentForServiceSignature:
                                      item.consentForServiceSignature.map(
                                        (servSign) => ({
                                          ...servSign,
                                          signature: '',
                                          date: null,
                                          verbalConsent: false,
                                          partitionKey: '',
                                          rowKey: '',
                                        }),
                                      ),
                                    consentToAccessInsuranceSignature:
                                      item.consentToAccessInsuranceSignature.map(
                                        (insSign) => ({
                                          ...insSign,
                                          signature: '',
                                          date: null,
                                          verbalConsent: false,
                                          partitionKey: '',
                                          rowKey: '',
                                        }),
                                      ),
                                    consentType: 'consentForChange',
                                    latestConsent: false,
                                  };
                                }
                                return item;
                              },
                            ),
                          }),
                        );
                      }}
                      sx={{
                        padding: '4px 8px 4px 8px',
                        borderRadius: '4px',
                        marginRight: '24px',
                        border: '1px solid #008C82',
                        backgroundColor: '#fff',
                      }}
                    >
                      <Box sx={{ display: 'flex' }} className="pr-xs">
                        {ifspSDPAndConsent.consent[mainIndex]
                          ?.isAdminAmendment && (
                          <UnDo style={{ width: '14px', height: '14px' }} />
                        )}
                      </Box>
                      <MediumTypography
                        labelid={'IFSP.ConvertToAdminAmendment'}
                        defaultlabel={
                          !ifspSDPAndConsent.consent[mainIndex]
                            ?.isAdminAmendment
                            ? 'Convert to Admin Amendment'
                            : 'Undo'
                        }
                        fontSize="12px"
                        fontweight={600}
                      />
                    </Box>
                  )}
                {!ifspSDPAndConsent.consent[mainIndex]?.isAdminAmendment &&
                  ifspPermission.hasClientEditPermission &&
                  showAddSectionCreationUi(mainIndex)}
                {mainIndex !== 0 &&
                  ifspSDPAndConsent.consent[mainIndex]?.completedOn &&
                  (ifspSDPAndConsent.consent[mainIndex]?.isAdminAmendment
                    ? ifspPermission.hasAdminAmendmentDeletePermission
                    : ifspPermission.hasIfspDeletePermissionAfterLock) &&
                  ifspPermission.hasClientEditPermission &&
                  ifspSDPAndConsent.isLocked && (
                    <Delete
                      className="cursorPointer mr-lg"
                      onClick={() => {
                        setOpenConsentDeleteWarning(true);
                        setConsentDeleteDetails({
                          consentId: ifspSDPAndConsent.consent[mainIndex].id,
                          consentIndex: mainIndex,
                        });
                      }}
                    />
                  )}
                <DownArrow
                  className="cursorPointer"
                  onClick={() => {
                    setOpenAccordianIndex(mainIndex);
                    setOpenAccordian(true);
                  }}
                />
              </Box>
            )}
          </Box>
          {openAccordian && mainIndex === openAccordianIndex && (
            <Box component="div">
              <Box
                ref={parentRef}
                style={{
                  pointerEvents:
                    (ifspSDPAndConsent.isLocked &&
                      !ifspSDPAndConsent.consent[mainIndex].isAdminAmendment &&
                      (!ifspPermission.hasIfspEditPermissionAfterLock ||
                        !ifspPermission.hasClientEditPermission)) ||
                    !ifspPermission.hasClientEditPermission
                      ? 'none'
                      : 'auto',
                  opacity:
                    (ifspSDPAndConsent.isLocked &&
                      !ifspSDPAndConsent.consent[mainIndex].isAdminAmendment &&
                      (!ifspPermission.hasIfspEditPermissionAfterLock ||
                        !ifspPermission.hasClientEditPermission)) ||
                    !ifspPermission.hasClientEditPermission
                      ? '0.5'
                      : '1 ',
                }}
                onKeyDownCapture={(e) => {
                  if (
                    (ifspSDPAndConsent.isLocked &&
                      !ifspSDPAndConsent.consent[mainIndex].isAdminAmendment &&
                      (!ifspPermission.hasIfspEditPermissionAfterLock ||
                        !ifspPermission.hasClientEditPermission)) ||
                    !ifspPermission.hasClientEditPermission
                  ) {
                    e.preventDefault();
                    e.stopPropagation();
                  }
                }}
                onFocus={() => {
                  if (
                    (ifspSDPAndConsent.isLocked &&
                      !ifspSDPAndConsent.consent[mainIndex].isAdminAmendment &&
                      (!ifspPermission.hasIfspEditPermissionAfterLock ||
                        !ifspPermission.hasClientEditPermission)) ||
                    !ifspPermission.hasClientEditPermission
                  ) {
                    if (parentRef.current) parentRef.current.focus();
                  }
                }}
              >
                {(ifspSDPAndConsent.consent[mainIndex]?.consentType ===
                  'consentForChange' &&
                  ifspSDPAndConsent.consent[mainIndex].completedOn &&
                  ifspSDPAndConsent.consent[mainIndex].isConsentSkipped) ||
                ifspSDPAndConsent.consent[mainIndex].isAdminAmendment ? (
                  <Box className="mt-md">
                    <CheckBoxComponent
                      ischecked={Boolean(
                        ifspSDPAndConsent.consent[openAccordianIndex]
                          .isConsentSkipped,
                      )}
                      CheckHandleChange={(value) =>
                        dispatch(
                          updateIfspSDPAndConsent({
                            ...ifspSDPAndConsent,
                            consent: ifspSDPAndConsent.consent.map(
                              (item, index) => {
                                if (index === openAccordianIndex) {
                                  return {
                                    ...item,
                                    isConsentSkipped:
                                      value.target.checked || null,
                                  };
                                }
                                return item;
                              },
                            ),
                          }),
                        )
                      }
                      labelid="IFSP.skipToConsent"
                      defaultlabelid="Service Coordinator or administrative attestation of outcome and service information amendments for data correction or discharge purposes only. Parent/Guardian consent is not required, or signature is on file."
                      disabled={
                        !!ifspData.completedOn ||
                        (!!ifspData.isAdminAmendment &&
                          !(ifspData.id
                            ? ifspPermission.hasAdminAmendmentEditPermission
                            : ifspPermission.hasAdminAmendmentAddPermission))
                      }
                    />
                  </Box>
                ) : null}
                {(ifspSDPAndConsent.consent[mainIndex]?.isAdminAmendment ||
                  ifspSDPAndConsent.consent[mainIndex]?.consentType ===
                    'consentForChange') && (
                  <>
                    <MediumTypography
                      labelid="IFSP.changesToServiceDelivery"
                      defaultlabel="Changes To Service Delivery"
                      fontSize="16px"
                      fontweight={600}
                      textColor="#2A4241"
                      className="pt-md pb-sm"
                    />
                    <CommentTextbox
                      className="bg__white translate"
                      placeholder={rctl.formatMessage({
                        id: 'IFSP.enterYourComments',
                        defaultMessage: 'Enter your comments',
                      })}
                      style={{
                        width: '840px',
                        textAlign: 'justify',
                      }}
                      rows={2}
                      maxLength={3000}
                      Value={
                        ifspSDPAndConsent.consent[openAccordianIndex]
                          .changesToServiceDeliveryComment
                      }
                      handlechange={(text) =>
                        dispatch(
                          updateIfspSDPAndConsent({
                            ...ifspSDPAndConsent,
                            consent: ifspSDPAndConsent.consent.map(
                              (item, index) => {
                                if (index === openAccordianIndex) {
                                  return {
                                    ...item,
                                    changesToServiceDeliveryComment:
                                      text || null,
                                  };
                                } else {
                                  return item;
                                }
                              },
                            ),
                          }),
                        )
                      }
                      disabled={
                        (!!ifspData.completedOn &&
                          !ifspPermission.hasIfspEditPermissionAfterLock &&
                          Boolean(!ifspData.isAdminAmendment)) ||
                        (ifspData.id &&
                          !ifspPermission.hasAdminAmendmentEditPermission &&
                          Boolean(ifspData.isAdminAmendment)) ||
                        (!ifspData.id &&
                          !ifspPermission.hasAdminAmendmentAddPermission &&
                          Boolean(ifspData.isAdminAmendment)) ||
                        (Boolean(!ifspData.isConsentSkipped) &&
                          Boolean(ifspData.isAdminAmendment)) ||
                        (Boolean(ifspData.isConsentSkipped) &&
                          Boolean(!ifspData.isAdminAmendment))
                      }
                    />
                  </>
                )}
                {ifspSDPAndConsent.consent[mainIndex]?.isAdminAmendment ? (
                  <Box>
                    {ifspSDPAndConsent.consent[openAccordianIndex]
                      ?.changesToServiceDeliveryComment === '' &&
                      ifspSDPAndConsent.consent[openAccordianIndex]
                        .isConsentSkipped && (
                        <MediumTypography
                          labelid="IFSP.DateRed"
                          defaultlabel="Changes To Service Delivery is required"
                          textColor="red"
                        />
                      )}
                    <MediumTypography
                      labelid="sd"
                      defaultlabel="Signature"
                      fontSize="16px"
                      fontweight={600}
                      textColor="#2A4241"
                      className="pt-md pb-sm"
                    />
                    <Box sx={{ paddingBottom: '24px' }}>
                      {ifspSDPAndConsent.consent[openAccordianIndex]
                        ?.adminAmendmentSignature?.signature === '' && (
                        <Box className="flex__ align__items__center">
                          <Box>
                            <ButtonComponent
                              className="btn-primary btn-cancel signature_add_Box"
                              labelId="Insurance.Addsignature"
                              defaultLabelId="Add Signature"
                              variantType="outlined"
                              onClick={() => setSignClicked(true)}
                              disabled={
                                (ifspData.id &&
                                  !ifspPermission.hasAdminAmendmentEditPermission) ||
                                (!ifspData.id &&
                                  !ifspPermission.hasAdminAmendmentAddPermission) ||
                                !ifspData.isConsentSkipped
                              }
                            />
                            {ifspSDPAndConsent.consent[openAccordianIndex]
                              ?.adminAmendmentSignature?.signature === '' &&
                              ifspSDPAndConsent.consent[openAccordianIndex]
                                .isConsentSkipped && (
                                <MediumTypography
                                  labelid="IFSP.DateRed"
                                  defaultlabel="Signature is required"
                                  textColor="red"
                                  className="pt-sm"
                                />
                              )}
                          </Box>
                          <Box sx={{ width: '200px', paddingLeft: '16px' }}>
                            <DatePickerComponent
                              key={
                                ifspSDPAndConsent.consent[openAccordianIndex]
                                  .adminAmendmentSignature?.date
                              }
                              className="bg__white"
                              labelid={'Date'}
                              defaultlabelid={'Date'}
                              value={dayjs(
                                ifspSDPAndConsent.consent[openAccordianIndex]
                                  .adminAmendmentSignature?.date,
                              )}
                              handlechange={(dateValue) => {
                                if (dateValue) {
                                  const formattedDate =
                                    dayjs(dateValue).format('MM/DD/YYYY');
                                  dispatch(
                                    updateIfspSDPAndConsent({
                                      ...ifspSDPAndConsent,
                                      consent: ifspSDPAndConsent.consent.map(
                                        (item, index) => {
                                          if (index === openAccordianIndex) {
                                            return {
                                              ...item,
                                              adminAmendmentSignature: {
                                                ...item.adminAmendmentSignature,
                                                date: formattedDate,
                                              },
                                            };
                                          } else {
                                            return item;
                                          }
                                        },
                                      ),
                                    }),
                                  );
                                } else {
                                  dispatch(
                                    updateIfspSDPAndConsent({
                                      ...ifspSDPAndConsent,
                                      consent: ifspSDPAndConsent.consent.map(
                                        (item, index) => {
                                          if (index === openAccordianIndex) {
                                            return {
                                              ...item,
                                              adminAmendmentSignature: {
                                                ...item.adminAmendmentSignature,
                                                date: null,
                                              },
                                            };
                                          } else {
                                            return item;
                                          }
                                        },
                                      ),
                                    }),
                                  );
                                }
                              }}
                              disabledDate={
                                (ifspData.id &&
                                  !ifspPermission.hasAdminAmendmentEditPermission) ||
                                (!ifspData.id &&
                                  !ifspPermission.hasAdminAmendmentAddPermission) ||
                                !ifspSDPAndConsent.consent[openAccordianIndex]
                                  .adminAmendmentSignature?.signature
                              }
                            />
                            {ifspSDPAndConsentFormValidations.adminAmendmentSignDate
                              .filter((item) => item.errorIndex === mainIndex)
                              .map((item) => (
                                <MediumTypography
                                  key={item.errorMessageId}
                                  labelid={item.errorMessageId}
                                  defaultlabel={item.errorMessage}
                                  textColor="red"
                                />
                              ))}
                          </Box>
                        </Box>
                      )}

                      {ifspSDPAndConsent.consent[openAccordianIndex]
                        ?.adminAmendmentSignature?.signature !== '' && (
                        <Box className="flex__ align__items__center">
                          <ButtonComponent
                            className="btn-primary btn-cancel signature_view_Box"
                            labelId={'ProgressNoteViewSignature'}
                            defaultLabelId={'View signature'}
                            variantType="outlined"
                            LeftIcon={<Editsignature />}
                            onClick={() => setSignClicked(true)}
                          />
                          <Box sx={{ width: '200px', paddingLeft: '16px' }}>
                            <DatePickerComponent
                              key={
                                ifspSDPAndConsent.consent[openAccordianIndex]
                                  .adminAmendmentSignature?.date
                              }
                              className="bg__white"
                              labelid={'Date'}
                              defaultlabelid={'Date'}
                              value={dayjs(
                                ifspSDPAndConsent.consent[openAccordianIndex]
                                  .adminAmendmentSignature?.date,
                              )}
                              handlechange={(dateValue) => {
                                if (dateValue) {
                                  const formattedDate =
                                    dayjs(dateValue).format('MM/DD/YYYY');
                                  dispatch(
                                    updateIfspSDPAndConsent({
                                      ...ifspSDPAndConsent,
                                      consent: ifspSDPAndConsent.consent.map(
                                        (item, index) => {
                                          if (index === openAccordianIndex) {
                                            return {
                                              ...item,
                                              adminAmendmentSignature: {
                                                ...item.adminAmendmentSignature,
                                                date: formattedDate,
                                              },
                                            };
                                          } else {
                                            return item;
                                          }
                                        },
                                      ),
                                    }),
                                  );
                                } else {
                                  dispatch(
                                    updateIfspSDPAndConsent({
                                      ...ifspSDPAndConsent,
                                      consent: ifspSDPAndConsent.consent.map(
                                        (item, index) => {
                                          if (index === openAccordianIndex) {
                                            return {
                                              ...item,
                                              adminAmendmentSignature: {
                                                ...item.adminAmendmentSignature,
                                                date: null,
                                              },
                                            };
                                          } else {
                                            return item;
                                          }
                                        },
                                      ),
                                    }),
                                  );
                                }
                              }}
                              disabledDate={
                                (ifspData.id &&
                                  !ifspPermission.hasAdminAmendmentEditPermission) ||
                                (!ifspData.id &&
                                  !ifspPermission.hasAdminAmendmentAddPermission) ||
                                !ifspData.isConsentSkipped
                              }
                            />
                            {!ifspSDPAndConsent.consent[openAccordianIndex]
                              .adminAmendmentSignature?.date &&
                              ifspSDPAndConsent.consent[openAccordianIndex]
                                .adminAmendmentSignature?.signature && (
                                <MediumTypography
                                  labelid="IFSP.DateRed"
                                  defaultlabel="Date is required"
                                  textColor="red"
                                />
                              )}
                          </Box>
                        </Box>
                      )}
                    </Box>

                    {signClicked && (
                      <SignatureComponent
                        signClicked={signClicked}
                        labelId="signatureText"
                        defaultLabelId="Signature"
                        onCancelClick={onCancelClick}
                        signature={
                          ifspSDPAndConsent.consent[openAccordianIndex]
                            .adminAmendmentSignature.signature ?? ''
                        }
                        signaturePartitionKey={
                          ifspSDPAndConsent.consent[openAccordianIndex]
                            .adminAmendmentSignature.partitionKey ?? ''
                        }
                        signatureRowKey={
                          ifspSDPAndConsent.consent[openAccordianIndex]
                            .adminAmendmentSignature.rowKey ?? ''
                        }
                        signatureSaveOrUPdate={onSignatureSave}
                        resetCallBackForTypeEmployee={clearSignature}
                        handleSuccess={handleSuccess}
                        type="Employee"
                        hideRemoveButton={
                          !!ifspData.completedOn &&
                          !ifspPermission.hasAdminAmendmentEditPermission
                        }
                      />
                    )}
                  </Box>
                ) : null}
                {ifspSDPAndConsent.consent[mainIndex]?.consentType ===
                  'consent' &&
                !ifspSDPAndConsent.consent[mainIndex]?.isAdminAmendment ? (
                  <Box>
                    <MediumTypography
                      labelid="IFSP.Eligibility"
                      defaultlabel="Eligibility"
                      fontSize="16px"
                      fontweight={600}
                      textColor="#2A4241"
                      className="pt-md pb-md"
                    />
                    <MediumTypography
                      labelid="IFSP.ifspServicesProvidedForAsLongAs"
                      defaultlabel="IFSP services are provided for as long as a child is eligible or until the parent revokes consent for any or all services."
                      fontweight={400}
                      textColor="#2A4241"
                    />
                    <Box component="div" className="pl-md pt-sm">
                      <CustomRadioButton
                        data={[
                          {
                            value: 'iseligible',
                            labelId: 'IFSP.IsEligible',
                            defaultLabel:
                              'Is eligible based on the eligibility evaluation and assessment completed',
                          },
                          {
                            value: 'untilnotonthirdbirthday',
                            labelId: 'IFSP.UntilButNotOnOurChildsThirdBirthday',
                            defaultLabel:
                              "Until (but not on) our child's third birthday based on a diagnosis from the DPH Diagnosed Conditions List.",
                          },
                        ]}
                        value={
                          ifspSDPAndConsent.consent[openAccordianIndex]
                            .isEligibleUntilThirdBirthday
                        }
                        onSelectItem={(value) => {
                          if (value) {
                            if (value === 'untilnotonthirdbirthday') {
                              dispatch(
                                updateIfspSDPAndConsent({
                                  ...ifspSDPAndConsent,
                                  consent: ifspSDPAndConsent.consent.map(
                                    (item, index) => {
                                      if (index === openAccordianIndex) {
                                        return {
                                          ...item,
                                          isEligibleUntilThirdBirthday: value,
                                          eligibleTool: {
                                            id: '',
                                            label: '',
                                          },
                                          isEligibleFor: '',
                                        };
                                      }
                                      return item;
                                    },
                                  ),
                                }),
                              );
                            } else {
                              dispatch(
                                updateIfspSDPAndConsent({
                                  ...ifspSDPAndConsent,
                                  consent: ifspSDPAndConsent.consent.map(
                                    (item, index) => {
                                      if (index === openAccordianIndex) {
                                        return {
                                          ...item,
                                          isEligibleUntilThirdBirthday: value,
                                        };
                                      }
                                      return item;
                                    },
                                  ),
                                }),
                              );
                            }
                          }
                        }}
                        row={false}
                        flexDirection="column"
                        paddingY="4px"
                        disable={
                          (!!ifspData.completedOn &&
                            !ifspPermission.hasIfspEditPermissionAfterLock) ||
                          Boolean(
                            ifspSDPAndConsent.consent[openAccordianIndex]
                              .isConsentSkipped,
                          )
                        }
                      />
                    </Box>
                    {ifspSDPAndConsent.consent[openAccordianIndex]
                      .isEligibleUntilThirdBirthday === 'iseligible' && (
                      <Box component="div">
                        <Grid container className="alignItemCenter pt-sm">
                          <Grid item>
                            <MediumTypography
                              labelid="IFSP.EligibilityEvaluation"
                              defaultlabel="Eligibility evaluation:"
                              className="pr-md"
                              fontweight={400}
                              textColor="#2A4241"
                            />
                          </Grid>
                          <Grid item>
                            <AutocompleteSearch
                              labelId={'IFSP.Tool'}
                              defaultId={'Tool'}
                              optionHintId={'noemployeeDropdownTextId'}
                              sxProps={{
                                [`& .${autocompleteClasses.popupIndicator}`]: {
                                  transform: 'none',
                                },
                                backgroundColor: '#fff',
                                width: '220px',
                              }}
                              selectedValue={
                                tools.find(
                                  (item) =>
                                    item.id ===
                                    ifspSDPAndConsent.consent[
                                      openAccordianIndex
                                    ].eligibilityEvaluationTool,
                                ) ?? null
                              }
                              data={tools}
                              onSelectItem={(value: OptionType | null) => {
                                if (value) {
                                  dispatch(
                                    updateIfspSDPAndConsent({
                                      ...ifspSDPAndConsent,
                                      consent: ifspSDPAndConsent.consent.map(
                                        (item, index) => {
                                          if (index === openAccordianIndex) {
                                            return {
                                              ...item,
                                              eligibilityEvaluationTool:
                                                value.id,
                                            };
                                          }
                                          return item;
                                        },
                                      ),
                                    }),
                                  );
                                } else {
                                  dispatch(
                                    updateIfspSDPAndConsent({
                                      ...ifspSDPAndConsent,
                                      consent: ifspSDPAndConsent.consent.map(
                                        (item, index) => {
                                          if (index === openAccordianIndex) {
                                            return {
                                              ...item,
                                              eligibilityEvaluationTool: null,
                                            };
                                          }
                                          return item;
                                        },
                                      ),
                                    }),
                                  );
                                }
                              }}
                              disableLabel={false}
                              disabled={
                                (!!ifspData.completedOn &&
                                  !ifspPermission.hasIfspEditPermissionAfterLock) ||
                                Boolean(
                                  ifspSDPAndConsent.consent[openAccordianIndex]
                                    .isConsentSkipped,
                                )
                              }
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <MediumTypography
                              labelid="IFSP.IsEligibleFor"
                              defaultlabel="Is Eligible for:"
                              className="pr-md"
                              fontweight={400}
                              textColor="#2A4241"
                            />
                            <CommentTextbox
                              className="bg__white translate"
                              placeholder={rctl.formatMessage({
                                id: 'IFSP.enterYourComments',
                                defaultMessage: 'Enter your comments',
                              })}
                              style={{
                                width: '840px',
                                textAlign: 'justify',
                              }}
                              rows={2}
                              maxLength={3000}
                              Value={
                                ifspSDPAndConsent.consent[openAccordianIndex]
                                  .isEligibleForComment
                              }
                              handlechange={(text) =>
                                dispatch(
                                  updateIfspSDPAndConsent({
                                    ...ifspSDPAndConsent,
                                    consent: ifspSDPAndConsent.consent.map(
                                      (item, index) => {
                                        if (index === openAccordianIndex) {
                                          return {
                                            ...item,
                                            isEligibleForComment: text || null,
                                          };
                                        } else {
                                          return item;
                                        }
                                      },
                                    ),
                                  }),
                                )
                              }
                              disabled={
                                (!!ifspData.completedOn &&
                                  !ifspPermission.hasIfspEditPermissionAfterLock) ||
                                Boolean(
                                  ifspSDPAndConsent.consent[openAccordianIndex]
                                    .isConsentSkipped,
                                )
                              }
                            />
                          </Grid>
                        </Grid>
                        <Grid container className="alignItemCenter pt-sm">
                          <Grid item>
                            <MediumTypography
                              labelid="IFSP.AssessmentCompletedOn"
                              defaultlabel="Assessment completed on:"
                              className="pr-md"
                              fontweight={400}
                              textColor="#2A4241"
                            />
                          </Grid>
                          <Grid item>
                            <DatePickerComponent
                              key={
                                ifspSDPAndConsent.consent[openAccordianIndex]
                                  .assessmentCompletedOn
                              }
                              className="bg__white"
                              labelid={'Date'}
                              defaultlabelid={'Date'}
                              value={dayjs(
                                ifspSDPAndConsent.consent[openAccordianIndex]
                                  .assessmentCompletedOn,
                              )}
                              handlechange={(dateValue: Dayjs | null) => {
                                if (dateValue) {
                                  const formattedDate =
                                    dayjs(dateValue).format('MM/DD/YYYY');
                                  dispatch(
                                    updateIfspSDPAndConsent({
                                      ...ifspSDPAndConsent,
                                      consent: ifspSDPAndConsent.consent.map(
                                        (item, index) => {
                                          if (index === openAccordianIndex) {
                                            return {
                                              ...item,
                                              assessmentCompletedOn:
                                                formattedDate,
                                            };
                                          } else {
                                            return item;
                                          }
                                        },
                                      ),
                                    }),
                                  );
                                } else {
                                  dispatch(
                                    updateIfspSDPAndConsent({
                                      ...ifspSDPAndConsent,
                                      consent: ifspSDPAndConsent.consent.map(
                                        (item, index) => {
                                          if (index === openAccordianIndex) {
                                            return {
                                              ...item,
                                              assessmentCompletedOn: null,
                                            };
                                          } else {
                                            return item;
                                          }
                                        },
                                      ),
                                    }),
                                  );
                                }
                              }}
                              disabledDate={
                                (!!ifspData.completedOn &&
                                  !ifspPermission.hasIfspEditPermissionAfterLock) ||
                                Boolean(
                                  ifspSDPAndConsent.consent[openAccordianIndex]
                                    .isConsentSkipped,
                                )
                              }
                            />
                            {ifspSDPAndConsentFormValidations.assessmentCompletedOn
                              .filter((item) => item.errorIndex === mainIndex)
                              .map((item) => (
                                <MediumTypography
                                  key={item.errorMessageId}
                                  labelid={item.errorMessageId}
                                  defaultlabel={item.errorMessage}
                                  textColor="red"
                                />
                              ))}
                          </Grid>
                        </Grid>
                      </Box>
                    )}
                    <Grid container className="alignItemCenter pt-sm">
                      <Grid item>
                        <MediumTypography
                          labelid="IFSP.EligibilityMustBeReestablishedOn"
                          defaultlabel="Eligibility must be re-established on:"
                          className="pr-md"
                          fontweight={400}
                          textColor="#2A4241"
                        />
                      </Grid>
                      <Grid item>
                        <DatePickerComponent
                          key={
                            ifspSDPAndConsent.consent[openAccordianIndex]
                              .reestablishmentDate
                          }
                          className="bg__white"
                          labelid={'Date'}
                          defaultlabelid={'Date'}
                          value={dayjs(
                            ifspSDPAndConsent.consent[openAccordianIndex]
                              .reestablishmentDate,
                          )}
                          handlechange={(dateValue: Dayjs | null) => {
                            if (dateValue) {
                              const formattedDate =
                                dayjs(dateValue).format('MM/DD/YYYY');
                              dispatch(
                                updateIfspSDPAndConsent({
                                  ...ifspSDPAndConsent,
                                  consent: ifspSDPAndConsent.consent.map(
                                    (item, index) => {
                                      if (index === openAccordianIndex) {
                                        return {
                                          ...item,
                                          reestablishmentDate: formattedDate,
                                        };
                                      } else {
                                        return item;
                                      }
                                    },
                                  ),
                                }),
                              );
                            } else {
                              dispatch(
                                updateIfspSDPAndConsent({
                                  ...ifspSDPAndConsent,
                                  consent: ifspSDPAndConsent.consent.map(
                                    (item, index) => {
                                      if (index === openAccordianIndex) {
                                        return {
                                          ...item,
                                          reestablishmentDate: null,
                                        };
                                      } else {
                                        return item;
                                      }
                                    },
                                  ),
                                }),
                              );
                            }
                          }}
                          disabledDate={
                            (!!ifspData.completedOn &&
                              !ifspPermission.hasIfspEditPermissionAfterLock) ||
                            Boolean(
                              ifspSDPAndConsent.consent[openAccordianIndex]
                                .isConsentSkipped,
                            )
                          }
                        />
                        {ifspSDPAndConsentFormValidations.reestablishedDate
                          .filter((item) => item.errorIndex === mainIndex)
                          .map((item) => (
                            <MediumTypography
                              key={item.errorMessageId}
                              labelid={item.errorMessageId}
                              defaultlabel={item.errorMessage}
                              textColor="red"
                            />
                          ))}
                      </Grid>
                    </Grid>
                    <MediumTypography
                      labelid="IFSP.servicesMayOccurForLessThan"
                      defaultlabel="*Services may occurforlessthan the specified period based on the child's age atthe time of the eligibility evaluation. All EIservices end one day prior to the child'sthird birthday."
                      className="pt-sm"
                      fontweight={400}
                      textColor="#2A4241"
                    />
                  </Box>
                ) : null}
                {!ifspSDPAndConsent.consent[mainIndex]?.isAdminAmendment && (
                  <>
                    <MediumTypography
                      labelid="IFSP.familyRightsNotice"
                      defaultlabel="Family Rights Notice"
                      fontSize="16px"
                      fontweight={600}
                      textColor="#2A4241"
                      className="pt-md pb-md"
                    />
                    <AutocompleteSearch
                      labelId={'IFSP.familyRightsNotice'}
                      defaultId="Family Rights Notice"
                      optionHintId={'noemployeeDropdownTextId'}
                      key={
                        ifspSDPAndConsent?.consent?.[openAccordianIndex]
                          ?.familyRightsNotice?.id ?? 'empty'
                      }
                      sxProps={{
                        [`& .${autocompleteClasses.popupIndicator}`]: {
                          transform: 'none',
                        },
                        backgroundColor: '#fff',
                        width: '840px',
                      }}
                      data={ifspClientDetails.guardians.map((item) => ({
                        id: item.id.toString(),
                        label:
                          item.name && typeof item.name === 'string'
                            ? item.name
                            : '',
                      }))}
                      onSelectItem={(value: OptionType | null) => {
                        if (value) {
                          dispatch(
                            updateIfspSDPAndConsent({
                              ...ifspSDPAndConsent,
                              consent: ifspSDPAndConsent.consent.map(
                                (item, index) => {
                                  if (index === openAccordianIndex) {
                                    return {
                                      ...item,
                                      familyRightsNotice: {
                                        id: value.id || null,
                                        label: value.label || null,
                                      },
                                    };
                                  }
                                  return item;
                                },
                              ),
                            }),
                          );
                        } else {
                          dispatch(
                            updateIfspSDPAndConsent({
                              ...ifspSDPAndConsent,
                              consent: ifspSDPAndConsent.consent.map(
                                (item, index) => {
                                  if (index === openAccordianIndex) {
                                    return {
                                      ...item,
                                      familyRightsNotice: {
                                        id: null,
                                        label: null,
                                      },
                                    };
                                  }
                                  return item;
                                },
                              ),
                            }),
                          );
                        }
                      }}
                      selectedValue={{
                        id:
                          ifspSDPAndConsent?.consent?.[openAccordianIndex]
                            ?.familyRightsNotice?.id ?? '',
                        label:
                          ifspSDPAndConsent?.consent?.[openAccordianIndex]
                            ?.familyRightsNotice?.label ?? '',
                      }}
                      disableLabel={false}
                      disabled={
                        (!!ifspData.completedOn &&
                          !ifspPermission.hasIfspEditPermissionAfterLock) ||
                        Boolean(
                          ifspSDPAndConsent.consent[openAccordianIndex]
                            .isConsentSkipped,
                        )
                      }
                    />
                    <MediumTypography
                      labelid="IFSP.understandingTheConsent"
                      defaultlabel="I/We have been informed of and received a copy of our Family Rights during the IFSP development process and understand that any accepted services will be provided."
                      fontweight={400}
                      textColor="#2A4241"
                      className="pt-lg"
                    />
                    <MediumTypography
                      labelid="IFSP.consentForService"
                      defaultlabel="Consent For Service"
                      fontSize="16px"
                      fontweight={600}
                      textColor="#2A4241"
                      className="pt-md"
                    />
                  </>
                )}
                {ifspSDPAndConsent.consent[mainIndex]?.consentType ===
                  'consentForChange' &&
                !ifspSDPAndConsent.consent[mainIndex]?.isAdminAmendment ? (
                  <Box>
                    <MediumTypography
                      labelid="IFSP.parentRights"
                      defaultlabel="Parent have the right to provide, withhold or revoke consent for any and all services. Parent must give written consent for any change in EI services. Consent means that you have been made aware of changes and that you agree to them. Any service for which a parent provides consent must be provided within 30 days."
                      fontweight={400}
                      textColor="#2A4241"
                      className="pt-sm"
                    />
                  </Box>
                ) : null}
                {ifspSDPAndConsent.consent[mainIndex]
                  ?.isAdminAmendment ? null : (
                  <>
                    <Box
                      component="div"
                      className="flex__ align__items__center pt-md"
                    >
                      <CheckBoxComponent
                        ischecked={Boolean(
                          ifspSDPAndConsent.consent[openAccordianIndex]
                            .participatedInIfspDevelopment,
                        )}
                        CheckHandleChange={(value) =>
                          dispatch(
                            updateIfspSDPAndConsent({
                              ...ifspSDPAndConsent,
                              consent: ifspSDPAndConsent.consent.map(
                                (item, i) => {
                                  if (i === openAccordianIndex) {
                                    return {
                                      ...item,
                                      participatedInIfspDevelopment:
                                        value.target.checked || null,
                                    };
                                  }
                                  return item;
                                },
                              ),
                            }),
                          )
                        }
                        className="pl-sm"
                        disabled={
                          !!ifspData.completedOn ||
                          Boolean(
                            ifspSDPAndConsent.consent[openAccordianIndex]
                              .isConsentSkipped,
                          )
                        }
                        labelid="IFSP.participatedIFSP"
                        defaultlabelid="I/We have participated in the development of our IFSP and:"
                      />
                    </Box>
                    {ifspSDPAndConsentFormValidations.participatedInIfspDevelopment
                      .filter((item) => item.errorIndex === mainIndex)
                      .map((item) => (
                        <MediumTypography
                          key={item.errorMessageId}
                          labelid={item.errorMessageId}
                          defaultlabel={item.errorMessage}
                          textColor="red"
                          className="pl-sm"
                        />
                      ))}
                    {ifspSDPAndConsentFormValidations.consentForServiceagreeDisagreeService
                      .filter((item) => item.errorIndex === mainIndex)
                      .map((item) => (
                        <MediumTypography
                          key={item.errorMessageId}
                          labelid={item.errorMessageId}
                          defaultlabel={item.errorMessage}
                          textColor="red"
                          className="pl-sm"
                        />
                      ))}
                    <Box component="div" className="pl-lg pt-xs">
                      <CustomRadioButton
                        data={[
                          {
                            value: 'agree',
                            labelId: 'IFSP.agree',
                            defaultLabel:
                              'I/We agree to to the services described in this plan.',
                          },
                          {
                            value: 'disagree',
                            labelId: 'IFSP.disagree',
                            defaultLabel:
                              'I/We decline IFSP services at this time',
                          },
                          {
                            value: 'agreeException',
                            labelId: 'IFSP.agreeException',
                            defaultLabel:
                              'I/We agree to the services in this plan with the following exceptions',
                          },
                        ]}
                        value={
                          ifspSDPAndConsent.consent[openAccordianIndex]
                            .agreeDisagreeService
                        }
                        onSelectItem={(value) => {
                          if (value) {
                            dispatch(
                              updateIfspSDPAndConsent({
                                ...ifspSDPAndConsent,
                                consent: ifspSDPAndConsent.consent.map(
                                  (item, index) => {
                                    if (index === openAccordianIndex) {
                                      return {
                                        ...item,
                                        agreeDisagreeService: value,
                                      };
                                    }
                                    return item;
                                  },
                                ),
                              }),
                            );
                          }
                        }}
                        row={false}
                        flexDirection="column"
                        paddingY="4px"
                        disable={
                          (!!ifspData.completedOn &&
                            !ifspPermission.hasIfspEditPermissionAfterLock) ||
                          Boolean(
                            ifspSDPAndConsent.consent[openAccordianIndex]
                              .isConsentSkipped,
                          )
                        }
                      />
                    </Box>
                    <MediumTypography
                      labelid="IFSP.exceptionList"
                      defaultlabel="List exceptions"
                      fontSize="16px"
                      fontweight={600}
                      textColor="#2A4241"
                      className="pt-md"
                    />
                    <CommentTextbox
                      className="bg__white translate"
                      placeholder={rctl.formatMessage({
                        id: 'IFSP.enterYourComments',
                        defaultMessage: 'Enter your comments',
                      })}
                      style={{
                        width: '840px',
                        textAlign: 'justify',
                      }}
                      rows={2}
                      maxLength={500}
                      Value={
                        ifspSDPAndConsent.consent[openAccordianIndex]
                          .listExceptionsComment
                      }
                      handlechange={(text) =>
                        dispatch(
                          updateIfspSDPAndConsent({
                            ...ifspSDPAndConsent,
                            consent: ifspSDPAndConsent.consent.map(
                              (item, index) => {
                                if (index === openAccordianIndex) {
                                  return {
                                    ...item,
                                    listExceptionsComment: text || null,
                                  };
                                }
                                return item;
                              },
                            ),
                          }),
                        )
                      }
                      disabled={
                        (!!ifspData.completedOn &&
                          !ifspPermission.hasIfspEditPermissionAfterLock) ||
                        Boolean(
                          ifspSDPAndConsent.consent[openAccordianIndex]
                            .isConsentSkipped,
                        )
                      }
                    />
                    {ifspSDPAndConsent?.consent?.[
                      openAccordianIndex
                    ]?.consentForServiceSignature?.map((item, index) => (
                      <IfspConsentSignture
                        onUpdateSignature={(
                          updatedSignature: IfspConsentSignatureType,
                        ) =>
                          handleConsentForServiceSignature(
                            updatedSignature,
                            index,
                          )
                        }
                        signatures={item}
                        key={item.id}
                        index={index}
                        disabled={
                          !!ifspData.completedOn ||
                          !ifspData.participatedInIfspDevelopment ||
                          Boolean(ifspData.isConsentSkipped)
                        }
                        isVerbalConsentRequired={Boolean(
                          ifspSDPAndConsent.consent[openAccordianIndex]
                            .uiVersion === 1,
                        )}
                        isPaperConsentRequired={Boolean(
                          (ifspSDPAndConsent.consent[openAccordianIndex]
                            .uiVersion ?? 0) > 1,
                        )}
                      />
                    ))}
                    {ifspSDPAndConsentFormValidations.consentForServiceNotSigned
                      .filter((item) => item.errorIndex === mainIndex)
                      .map((item) => (
                        <MediumTypography
                          key={item.errorMessageId}
                          labelid={item.errorMessageId}
                          defaultlabel={item.errorMessage}
                          textColor="red"
                          className="pl-sm"
                        />
                      ))}

                    <MediumTypography
                      labelid="IFSP.consentToAccessInsurance"
                      defaultlabel="Consent To Access Insurance"
                      fontSize="16px"
                      fontweight={600}
                      textColor="#2A4241"
                      className="pt-md"
                    />
                    <Box
                      component="div"
                      className="flex__ align__items__center"
                    >
                      <Box component="div" className="pt-xs">
                        <CheckBoxComponent
                          ischecked={Boolean(
                            ifspSDPAndConsent.consent[openAccordianIndex]
                              .consentToAccessInsurance,
                          )}
                          CheckHandleChange={(value) =>
                            dispatch(
                              updateIfspSDPAndConsent({
                                ...ifspSDPAndConsent,
                                consent: ifspSDPAndConsent.consent.map(
                                  (item, index) => {
                                    if (index === openAccordianIndex) {
                                      return {
                                        ...item,
                                        consentToAccessInsurance:
                                          value.target.checked || null,
                                      };
                                    }
                                    return item;
                                  },
                                ),
                              }),
                            )
                          }
                          disabled={
                            !!ifspData.completedOn ||
                            Boolean(
                              ifspSDPAndConsent.consent[openAccordianIndex]
                                .isConsentSkipped,
                            )
                          }
                          className="pl-sm"
                          labelid="IFSP.InsuranceContent"
                          defaultlabelid=" I/We consent for the EI Program to access our public and/ or private insurance for payment of Early Intervention services described in this plan."
                        />
                      </Box>
                    </Box>
                    {ifspSDPAndConsentFormValidations.consentToAccessInsurance
                      .filter((item) => item.errorIndex === mainIndex)
                      .map((item) => (
                        <MediumTypography
                          key={item.errorMessageId}
                          labelid={item.errorMessageId}
                          defaultlabel={item.errorMessage}
                          textColor="red"
                          className="pl-sm"
                        />
                      ))}
                    {ifspSDPAndConsent?.consent?.[
                      openAccordianIndex
                    ]?.consentToAccessInsuranceSignature?.map((item, index) => {
                      return (
                        <IfspConsentSignture
                          signatures={item}
                          key={item.id}
                          onUpdateSignature={(
                            updatedSignature: IfspConsentSignatureType,
                          ) =>
                            handleConsentToAccessInsuranceSignature(
                              updatedSignature,
                              index,
                            )
                          }
                          index={index}
                          disabled={
                            !!ifspData.completedOn ||
                            !ifspData.consentToAccessInsurance ||
                            Boolean(ifspData.isConsentSkipped)
                          }
                          isVerbalConsentRequired={
                            ifspSDPAndConsent.consent[openAccordianIndex]
                              .uiVersion === 1
                          }
                          isPaperConsentRequired={Boolean(
                            (ifspSDPAndConsent.consent[openAccordianIndex]
                              .uiVersion ?? 0) > 1,
                          )}
                        />
                      );
                    })}
                    {ifspSDPAndConsentFormValidations.consentToAccessInsuranceNotSigned
                      .filter((item) => item.errorIndex === mainIndex)
                      .map((item) => (
                        <MediumTypography
                          key={item.errorMessageId}
                          labelid={item.errorMessageId}
                          defaultlabel={item.errorMessage}
                          textColor="red"
                          className="pl-sm"
                        />
                      ))}
                  </>
                )}
              </Box>
            </Box>
          )}
        </Box>
      ))}
    </Box>
  );
};

export default IfspConsent;
